import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { LoggerService } from '../logger.service';
var UserModel = (function () {
    function UserModel(loggerService, localeId) {
        this.loggerService = loggerService;
        this.suppressAlerts = false;
        this.locale = localeId; // default to 'en-US'
        try {
            var url = window.location.search.substring(1);
            this.locale = this.checkQueryForUrl(url);
        }
        catch (e) {
            this.loggerService.error('Could not set locale from URL.');
        }
    }
    UserModel.prototype.checkQueryForUrl = function (locationQuery) {
        var locale = this.locale;
        if (locationQuery && locationQuery.length) {
            var q = locationQuery;
            var token = 'locale=';
            var idx = q.indexOf(token);
            if (idx >= 0) {
                var end = q.indexOf('&', idx);
                end = end !== -1 ? end : q.indexOf('#', idx);
                end = end !== -1 ? end : q.length;
                locale = q.substring(idx + token.length, end);
            }
        }
        return locale;
    };
    return UserModel;
}());
export { UserModel };
UserModel.decorators = [
    { type: Injectable },
];
/** @nocollapse */
UserModel.ctorParameters = function () { return [
    { type: LoggerService, },
    { type: undefined, decorators: [{ type: Inject, args: [LOCALE_ID,] },] },
]; };
//# sourceMappingURL=user.model.js.map